import React, {FC, ReactNode, useEffect, useRef} from "react"
import styled from "styled-components"

import id from "@irati/utils/id"

import FocusOnKeyboard from "@irati/ui/src/Button/helpers/FocusOnKeyboard"
import UserMenuDropdownOptions from "./UserMenuDropdownOptions"

const MenuDropdown = styled.div`
  position: relative;
`

interface Props {
  content?: ReactNode,
  tooltip: string,
  id?: string,
  show: boolean,
  onClick: () => void,
  onOutsideClick?: () => void
}

const HeaderMenu: FC<Props> = (props) => {
  const containerRef = useRef<any>()
  const contentRef = useRef<any>()

  const {children, content, tooltip, show, onClick} = props
  const idNamespace = id("desktop", props)

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick, true)

    return () => {
      document.removeEventListener("click", handleOutsideClick, true)
    }
  }, [])

  const handleOutsideClick = ({target}) => {
    const {onOutsideClick} = props

    const isClickingOutsideIcon = containerRef.current && !containerRef.current.contains(target)
    const isClickingOutsideContent = contentRef.current && !contentRef.current.contains(target)

    if (isClickingOutsideIcon && isClickingOutsideContent) {
      if (onOutsideClick) {
        onOutsideClick()
      }
    }
  }

  return (
    <MenuDropdown>
      <FocusOnKeyboard id={idNamespace} data-attach-tooltip={tooltip} onClick={onClick}>
        <div ref={containerRef}>{children}</div>
      </FocusOnKeyboard>

      {show && content && (
        <UserMenuDropdownOptions ref={contentRef} onClick={onClick}>
          {content}
        </UserMenuDropdownOptions>
      )}
    </MenuDropdown>
  )
}

export default HeaderMenu
